import React from 'react';
import App from './components/App.jsx';
import { createRoot } from 'react-dom/client';

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import '@shopify/polaris/build/esm/styles.css';

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
